import { useEffect, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';
import { Platform } from 'utils/platform';

import SpallaPlayer, { SpallaPlayerWebProps as SpallaPlayerProps } from '../SpallaPlayer';
import { usePlayer } from '../context';
import CTVAdsControls from './adsControls';
import CTVSpallaControls from './controls';
import PlayerLoading from './loading';

import { WebDiv } from 'components/WebDiv';

export type AdsState = {
  isAdsPlaying: boolean;
  adsCurrentTime: number;
  adsDuration: number;
  event: string | null;
};

const BACK_EVENT = 'back-remote-control';

const SpallaPlayerCTV = (props: SpallaPlayerProps) => {
  const { isVisible, isSpallaReady, setIsVisible, setFullScreen } = usePlayer();
  const [adsState, setAdsState] = useState<AdsState>({
    isAdsPlaying: false,
    adsCurrentTime: 0,
    adsDuration: 0,
    event: null,
  });

  const containerClass = useMemo(() => {
    if (isVisible) return 'navigation-container fullscreen';
    return 'navigation-container navigation-ignore display-none';
  }, [isVisible]);

  const handlePlayerEvent = (e: any) => {
    const isAdCurrentlyPlaying =
      !['adend', 'aderror'].includes(e?.event) &&
      Boolean(e?.isAdsPlaying) &&
      typeof e?.adsCurrentTime === 'number' &&
      typeof e?.adsDuration === 'number' &&
      e.adsCurrentTime >= 0 &&
      e.adsDuration > 0;

    const nextState = {
      event: e?.event ?? '',
      isAdsPlaying: isAdCurrentlyPlaying,
      adsCurrentTime: (e?.event === 'adend' ? e?.adsDuration : e?.adsCurrentTime) ?? 0,
      adsDuration: e?.adsDuration ?? 0,
    };

    setAdsState((prev) => (JSON.stringify(prev) === JSON.stringify(nextState) ? prev : nextState));
  };

  useEffect(() => {
    const handleBackEvent = () => {
      setFullScreen(false);
      setIsVisible(false);
    };

    window.addEventListener(BACK_EVENT, handleBackEvent);
    return () => window.removeEventListener(BACK_EVENT, handleBackEvent);
  }, []);

  return createPortal(
    <>
      <WebDiv className={containerClass} style={{ marginTop: 80 }}>
        <SpallaPlayer {...props} onPlayerEvent={(e) => handlePlayerEvent(e)} />
        {adsState.isAdsPlaying ? <CTVAdsControls adsState={adsState} /> : <CTVSpallaControls />}
      </WebDiv>
      {Platform.isTV && !isSpallaReady && isVisible && <PlayerLoading />}
    </>,
    document.querySelector('#root')!
  );
};

export default SpallaPlayerCTV;
